import { render, staticRenderFns } from "./render-concept.vue?vue&type=template&id=2b52bf52&"
import script from "./render-concept.vue?vue&type=script&lang=js&"
export * from "./render-concept.vue?vue&type=script&lang=js&"
import style0 from "./render-concept.vue?vue&type=style&index=0&id=2b52bf52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports